import { DayProgram } from './../../models/day-program.model';
import { Component } from '@angular/core';
import { NavController, NavParams, ModalController, ViewController, AlertController } from 'ionic-angular';
import { SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';
//Providers
import { ConfigProvider } from '../../providers/config-provider';
import { UtilProvider } from '../../providers/util-provider';
import { CongressoProvider } from '../../providers/congresso-provider';
import { CalendarProvider } from '../../providers/calendar-provider';
import { AuthProvider } from '../../providers/auth-provider';
import { StorageProvider } from '../../providers/storage-provider';
//Pages
import { VideoPage } from '../video/video';
//Components
import { CustomAlert } from '../../components/custom-alert.component';
import { CustomToastComponent } from '../../components/custom-toast/custom-toast';
import { RefreshInfoComponent } from '../../components/refresh-info/refresh-info.component';

//Models
import { Activity } from '../../models/activity.model';
import { LecturerProgram } from '../../models/lecturer-program.model';
import { Congresso } from '../../models/congresso.model';
import { User } from '../../models/user.model';
import { AtividadeCadastroProgramaModel } from '../../models/atividade-cadastro-programa.model';
import { UserProvider } from '../../providers/user-provider';

@Component({
    selector: 'page-atividade',
    templateUrl: 'atividade.html'
})
export class AtividadePage {
    public id: number;
    private congresso: Congresso;
    private user: User;
    public activity: Activity;
    public activities: Array<Activity>;
    public palestrantes: Array<LecturerProgram>;
    public convidados: Array<LecturerProgram>;
    public convidadosTema: Array<LecturerProgram>;
    public isCurrent: boolean = true;
    public LM: string = "LM";
    public SP: string = "SP";
    public CPO: string = "CPO";
    public CPG: string = "CPG";
    private ABT: string = "ABT";
    private ECR: string = "ECR";
    private activitiesInscIds: number[];
    private atividadesAssistidasIds: number[];
    private loaded: boolean;
    private allowCalendar: boolean;
    private lastRefreshDate: string;
    public viewModeCard: boolean = true;
    public urlCientifico = "";
    public liberado: boolean = true;

    constructor(public navCtrl: NavController,
        private modalCtrl: ModalController,
        private navParams: NavParams,
        private congressoProvider: CongressoProvider,
        public utilProvider: UtilProvider,
        public userProvider: UserProvider,
        private configProvider: ConfigProvider,
        private alert: CustomAlert,
        private toast: CustomToastComponent,
        private auth: AuthProvider,
        private storageProvider: StorageProvider,
        private calendarProvider: CalendarProvider,
        public sanitizer: DomSanitizer,
        public alertCtrl: AlertController) {

        this.activity = new Activity();
        this.palestrantes = new Array<LecturerProgram>();
        this.convidados = new Array<LecturerProgram>();
        this.convidadosTema = new Array<LecturerProgram>();
        this.congresso = JSON.parse(localStorage.getItem('congresso')) as Congresso;
        this.user = JSON.parse(localStorage.getItem('user')) as User;
        this.isCurrent = this.congresso.Ano == configProvider.ANO_ATUAL; //|| this.congresso.Liberado;
        this.liberado = this.congresso.Liberado
        this.viewModeCard = this.isCurrent || this.liberado;
        this.urlCientifico = configProvider.url.Cientifico;
        this.activitiesInscIds = localStorage.getItem('atividadesInscritas') ? JSON.parse(localStorage.getItem('atividadesInscritas')) as number[] : new Array<number>();
        this.atividadesAssistidasIds = localStorage.getItem('atividadesAssistidas') ? JSON.parse(localStorage.getItem('atividadesAssistidas')) as number[] : new Array<number>();
        //days = JSON.parse(localStorage.getItem('atividadesDia'))
        let days = new Array<DayProgram>();

        this.storageProvider.getting('atividadesDia').then((res) => {
            days = JSON.parse(res) as Array<DayProgram>;
            
            if (days && days.length) {
                days.forEach(x => {
                    Array.prototype.push.apply(this.activities, x.Atividades);
                });
            }
        });

        let areas = JSON.parse(localStorage.getItem('atividadesArea'));
        this.activities = new Array<Activity>();
       

        if (areas && areas.length) {
            areas.forEach(x => {
                Array.prototype.push.apply(this.activities, x.Atividades);
            });
        }

        this.loaded = false;

    }

    ionViewDidEnter() {
        this.user = this.storageProvider.get("user") as User;
        this.lastRefreshDate = this.storageProvider.get('lastRefreshDate');
        this.get();
    }

    allowsInscription(): boolean {
        return !this.isInscrito(this.activity) && this.canRegister();
    }

    get() {
        let self = this;
        self.id = self.navParams.get("id");
        self.activity = this.activities.filter(x => x.AtividadeId == self.id)[0];
        self.activity.Palestrantes = self.activity.AtividadesCadastro.map(p => p.Palestrantes[0]).filter(x => x);

        if (!self.activity.AtividadeId && self.utilProvider.isConnected(true)) {
            setTimeout(() => {
                this.congressoProvider.getAtividadeById(this.id)
                    .then(res => {

                        self.activity = res;
                        self.setAtivityData();
                    })
                    .catch(response => {
                        let err = response;
                        if (err) {

                            self.alert.showAlert('Falha de conexão', 'Não foi possível obter os dados do servidor');
                        }
                    });
            }, 0)
        }
        else {
            self.setAtivityData();
        }
    }

    setAtivityData() {
        let self = this;

        if (self.activity.HoraInicioAtividade) {
            self.activity.HoraInicioAtividade = self.utilProvider.formatHour(self.activity.HoraInicioAtividade);
            self.activity.HoraFimAtividade = self.utilProvider.formatHour(self.activity.HoraFimAtividade);
        }

        if (self.activity.Duracao) {
            self.activity.Duracao = self.utilProvider.formatHourInFull(self.activity.Duracao);
        }

        self.getConvidadosForTema();

        self.verifyVideos();
        this.loaded = true;
    }

    getConvidadosForTema(): Array<LecturerProgram> {
        let nextTema = this.activity.AtividadesCadastro.filter(x => x.Ordem > 1 && x.IsTema)[0] as AtividadeCadastroProgramaModel;
        if (nextTema)
            return this.convidadosTema = this.activity.Palestrantes.filter(p => p.Tipo != 'Palestrante' && p.Tipo != 'Palestrantes' && p.Ordem > 1 && p.Ordem < nextTema.Ordem);

        return this.convidadosTema = this.activity.Palestrantes.filter(p => p.Tipo != 'Palestrante' && p.Tipo != 'Palestrantes' && p.Ordem > 1);
    }

    getConvidados(a: AtividadeCadastroProgramaModel): Array<LecturerProgram> {
        let nextTema = this.activity.AtividadesCadastro.filter(x => x.Ordem > a.Ordem && x.IsTema)[0] as AtividadeCadastroProgramaModel;
        if (nextTema)
            return this.convidados = this.activity.Palestrantes.filter(p => p.Tipo != 'Palestrante' && p.Tipo != 'Palestrantes' && p.Ordem > a.Ordem && p.Ordem < nextTema.Ordem);

        return this.convidados = this.activity.Palestrantes.filter(p => p.Tipo != 'Palestrante' && p.Tipo != 'Palestrantes' && p.Ordem > a.Ordem);
    }

    async back() {
        this.navCtrl.pop();
    }

    goToSgunInscription() {
        window.open('http://sgun.sogesp.org.br/evento/inscricao', "_blank", "location=yes,toolbar=yes,hidden=no");
    }

    isInscrito(a: Activity) {
        return (localStorage.getItem('atividadesInscritas') ? JSON.parse(localStorage.getItem('atividadesInscritas')).some(x => x == a.AtividadeId) : false);
    }


    confirmPresence(participar: boolean) {
        let self = this;
        if (self.utilProvider.isConnected(true) && this.auth.isAuthorized()) {
            self.alert.showConfirm('Confirmação', 'Deseja ' + (participar ? 'confirmar' : 'cancelar') + ' sua inscrição na atividade: <strong>' + self.activity.TemaDaAtividade + '</strong>?', 'Sim', 'Não', function () {
                self.utilProvider.loadingShow();
                self.congressoProvider.confirmarPresencaAtividade(self.id, participar)
                    .then(res => {
                        res = JSON.parse(res);
                        self.utilProvider.loadingHide();
                        if (res.resposta.codigo == 0) {

                            let activities = self.calendarProvider.getAllActivities();
                            let atividade = activities.filter(x => x.AtividadeId == self.activity.AtividadeId)[0] as Activity;

                            if (participar) {
                                self.activity.InscritoNaAtividade = true;
                                //self.allowsInscription = false;
                                self.activitiesInscIds.push(self.activity.AtividadeId);
                                localStorage.setItem('atividadesInscritas', JSON.stringify(self.activitiesInscIds));

                                self.activity.VagasOcupadas++;

                                //if (+localStorage.getItem('config') > 0)
                                //    self.calendarProvider.create('', '').then((c) => {
                                //        c.addActivity(atividade, true);
                                //    });

                                self.alert.showAlert('Sucesso', 'Inscrição confirmada!');
                            }
                            else {
                                self.activity.InscritoNaAtividade = false;
                                //self.allowsInscription = true;
                                self.activitiesInscIds = self.activitiesInscIds.filter(x => x != self.activity.AtividadeId);
                                localStorage.setItem('atividadesInscritas', JSON.stringify(self.activitiesInscIds));

                                //if (+localStorage.getItem('config') > 0) {

                                //    self.calendarProvider.create('', '').then((c) => {
                                //        c.removeActivity(atividade, true);
                                //    });
                                //}

                                self.activity.VagasOcupadas--;
                                self.alert.showAlert('Sucesso', 'Inscrição cancelada!');
                            }
                        }
                        else if (res.resposta.codigo == -1 && res.resposta.retorno.error)
                            self.alert.showAlert('Atenção', res.resposta.retorno.error);
                        else if (res.resposta.codigo == -1 && res.resposta.retorno.Erro)
                            self.alert.showConfirm('Atenção', res.resposta.retorno.Erro.replace('<br><br>', ' '), 'Sim', 'Não', self.goToSgunInscription);
                        else if (res.resposta.retorno.Conflito) {
                            let conflitText = 'Você já reservou sua vaga para: \n\n"<b>' + res.resposta.retorno.SiglaAtividade + ' ' + res.resposta.retorno.OrdemAtividade + ' - ' + res.resposta.retorno.Descritivo +
                                '</b>" que ocorre na <b>' + res.resposta.retorno.Sigla + ' das ' + res.resposta.retorno.HoraInicio + ' às ' + res.resposta.retorno.HoraTermino +
                                '</b>.\n\nDeseja substituir por:\n\n<b>' + '"' + res.resposta.retorno.AtividadeCadastrar.SiglaAtividade + ' ' + res.resposta.retorno.AtividadeCadastrar.OrdemAtividade + ' - ' + res.resposta.retorno.AtividadeCadastrar.Descritivo + '</b>" que ocorre na <b>' +
                                res.resposta.retorno.AtividadeCadastrar.Sigla + ' das ' + res.resposta.retorno.AtividadeCadastrar.HoraInicio + ' às ' + res.resposta.retorno.AtividadeCadastrar.HoraTermino + '</b>';
                            //Substituir Presença
                            self.alert.showConfirm('Atenção', conflitText, 'Sim', 'Não', () => {
                                self.replacePresence(self.activity.AtividadeId, res.resposta.retorno.AtividadeId, self.user.Guid, self.user.Login, self.user.TipoAssociacaoId, self.user.CategoriaId);
                            });
                        }
                        else if (res.resposta.retorno[0].error) {
                            self.alert.showAlert('Atenção', res.resposta.retorno[0].error);
                            if (res.resposta.retorno[0].error === 'Não existem vagas para esta atividade!')
                                self.activity.VagasOcupadas = self.activity.VagasTotal;
                        }
                    })
                    .catch(response => {
                        let err = response;
                        if (err) {
                            self.utilProvider.loadingHide();

                            self.alert.showAlert('Falha de conexão', 'Não foi possível obter os dados do servidor');
                        }
                    });
            });
        }
    }

    replacePresence(addActivityId: number, removeActivityId: number, userGuid: string, userLogin: string, associationId: number, categoryId: number) {
        let self = this;
        if (self.utilProvider.isConnected(true) && this.auth.isAuthorized()) {
            self.utilProvider.loadingShow();
            self.congressoProvider.substituirPresencaAtividade(addActivityId, removeActivityId, userGuid, userLogin, associationId, categoryId)
                .then(res => {
                    res = JSON.parse(res);
                    if (res.resposta.codigo == 0) {
                        //self.allowsInscription = false;

                        let index = self.activitiesInscIds.indexOf(removeActivityId);

                        if (index != -1)
                            self.activitiesInscIds.splice(index, 1);

                        self.activitiesInscIds.push(addActivityId);
                        localStorage.setItem('atividadesInscritas', JSON.stringify(self.activitiesInscIds));

                        if (+localStorage.getItem('config') > 0) {
                            let activities = self.calendarProvider.getAllActivities();
                            let atividadeAntiga = activities.filter(x => x.AtividadeId == removeActivityId)[0] as Activity;
                            let atividadeNova = activities.filter(x => x.AtividadeId == addActivityId)[0] as Activity;

                            //self.calendarProvider.create('', '').then((c) => {
                            //    c.removeActivity(atividadeAntiga, false);
                            //    c.addActivity(atividadeNova, true);
                            //});
                        }
                        self.activity.VagasOcupadas++;
                        self.alert.showAlert('Sucesso', 'Subtituição confirmada!');
                    } else
                        self.alert.showAlert('Erro', res.resposta.retorno[0].error);

                    self.utilProvider.loadingHide();
                })
                .catch(response => {
                    let err = response;
                    if (err) {
                        self.utilProvider.loadingHide();

                        self.alert.showAlert('Falha de conexão', 'Não foi possível obter os dados do servidor');
                    }
                });
        }
    }

    verifyVideos() {

        // if (!this.isCurrent) {
        let self = this;

        let usuarioPermitido = self.user ? self.user.AnosParticipados.split(',').indexOf(self.congresso.Ano.toString()) != -1 || self.user.IsAdimplente : false;

        if (this.isCurrent)
            usuarioPermitido = self.user && self.user.InscricaoPaga;

        for (var i = 0; i < self.activity.AtividadesCadastro.length; i++) {
            var atividadeCadastro = self.activity.AtividadesCadastro[i];

            var atividade = self.activity,
                podeTerVideo,
                msg = null;

            podeTerVideo = atividadeCadastro.NomeAtividade.toLowerCase().indexOf('debate com a plateia') >= 0 || atividadeCadastro.NomeAtividade.toLowerCase().indexOf('discussão') >= 0;

            if (!podeTerVideo) {
                for (var j = 0; j < atividadeCadastro.Palestrantes.length; j++) {
                    var palestrante = atividadeCadastro.Palestrantes[j];

                    podeTerVideo = palestrante.Tipo != 'Revisor' && palestrante.Tipo != 'Revisora' && palestrante.Tipo != 'Secretário' && palestrante.Tipo != 'Secretária' &&
                        (atividade.Sigla == 'DBI' && palestrante.Tipo != 'Debatedor' && palestrante.Tipo != 'Debatedora' && palestrante.Tipo != 'Debatedores' &&
                            palestrante.Tipo != 'Debatedoras' || palestrante.Tipo != 'Coordenador' && palestrante.Tipo != 'Coordenadora' && palestrante.Tipo != 'Coordenadores' &&
                            palestrante.Tipo != 'Coordenadoras' && palestrante.Tipo != 'Debatedor' && palestrante.Tipo != 'Debatedora' && palestrante.Tipo != 'Debatedores' &&
                            palestrante.Tipo != 'Debatedoras');

                    if (!palestrante.AutorizacaoGravacao)
                        msg = 'Esta aula não foi gravada por não autorização do(a) palestrante.';
                }
            }

            atividadeCadastro.PodeTerVideo = podeTerVideo;

            if (self.utilProvider.isNullOrEmpty(msg)) {

                if (!usuarioPermitido && this.auth.isAuthorized(true))
                    if (self.isCurrent) {
                        msg = 'Este video está disponível somente para inscritos no congresso ' + self.congresso.Ano + '.';
                    }
                    else {
                        msg = 'Este video está disponível somente para inscritos que estiveram presentes no congresso ' + self.congresso.Ano + ' e para associados da SOGESP.';
                    }

                if (atividadeCadastro.PodeTerVideo && self.utilProvider.isNullOrEmpty(atividadeCadastro.UrlVideo)) {
                    msg = 'Esta aula ainda não está disponível.';
                }


                if (atividadeCadastro.VideoPrescritor && !self.auth.isAuthorized(true)) {
                    //self.auth.isAuthorized();
                    msg = 'Usuário não autenticado.';
                }
                else if (atividadeCadastro.VideoPrescritor && this.auth.isAuthorized(true) && !self.user.Prescritor) {
                    msg = 'Vídeo disponível apenas para prescritores.';
                    //self.alert.showAlert('Aviso', msg);
                }
            }

            atividadeCadastro.Mensagem = msg;
        }
        //}
    }

    openVideo(id: number, title: string, url: string, message: string, ativ: AtividadeCadastroProgramaModel) {
        if (this.utilProvider.isConnected(true) && this.auth.isAuthorized()) {
            let self = this;
            self.utilProvider.loadingShow();
           

            //Verifica se o usuário está logado em outro dispositivo
            this.auth.getUserLogged().then(res => {
                self.utilProvider.loadingHide();
                var user = res as User;

                let permitido = self.user ? self.user.AnosParticipados.split(',').indexOf(self.congresso.Ano.toString()) != -1 || self.user.IsAdimplente : false;

                if (!user) {
                    self.alert.showConfirm('Usuário não autenticado.', 'Faça login para assistir as aulas. Fazer login agora?', 'Sim', 'Não', () => {
                        this.auth.isAuthorized();
                    });
                }
                else if (user.InscricaoPaga && (user.Ingresso == null && this.congresso.IsOnline) && !permitido) {
                    self.alert.showAlert('Aviso', 'O seu prazo para acesso ao conteúdo expirou.');
                }
                else {

                    if (user && user.PermiteEmailMarketing === null || user.PermiteEmailMarketing === undefined) {
                        self.showEmailConfirm();
                    }

                    if (!user.InscricaoPaga && self.isCurrent && !permitido) {
                        message = 'Este video está disponível somente para inscritos no congresso ' + self.congresso.Ano + '.';
                    }

                    this.navCtrl.push(VideoPage, {
                        id: id,
                        title: title,
                        url: url,
                        message: message,
                        atividade: ativ
                    });
                }
            });
        }
    }

    descHasTwoLines() {
        return this.activity.Descricao ? this.activity.Descricao.length < 26 : true;
    }

    canRegister() {
        return this.isCurrent &&
            this.activity.Sigla != this.LM &&
            this.activity.Sigla != this.SP &&
            this.activity.Sigla != this.ABT &&
            this.activity.Sigla != this.ECR;
    }

    showVagas() {
        return (this.activity.VagasTotal - this.activity.VagasOcupadas <= 50 && this.activity.VagasTotal - this.activity.VagasOcupadas > 0)
    }

    wasViewed(id: number) {
        return (localStorage.getItem('atividadesAssistidas') && localStorage.getItem('user') ? JSON.parse(localStorage.getItem('atividadesAssistidas')).some((x: number) => x == id) : false);
    }

    changeViewMode() {
        this.viewModeCard = !this.viewModeCard;
    }

    showEmailConfirm() {
        let self = this;

        let mensagem = 'No momento de sua inscrição, você informou seu e-mail para que a SOGESP possa garantir sua identificação, enviar informativos e permitir o acesso ao sistema do Congresso Online. Essa informação, assim como todas as outras coletadas <b>NÃO</b> serão compartilhadas com terceiros, <b>salvo mediante sua previa e expressa autorização.</b><br>.' +
            'Assim, a SOGESP gostaria de questionar se você autoriza o recebimento de materiais publicitários dos patrocinadores deste evento? Em caso positivo, neste ato, <b>você consente com a utilização de seu e-mail também com a finalidade publicitária.</b>';

        let alert = this.alertCtrl.create({
            title: 'Congresso Online',
            subTitle: mensagem,
            cssClass: 'alert-permite-email',
            enableBackdropDismiss: false,
            buttons: [
                {
                    text: 'Não',
                    handler: () => {
                        self.utilProvider.loadingShow();
                        self.userProvider.updateEmailMarketingPermission(self.user.SgunId, false).then(res => {
                            self.utilProvider.loadingHide();
                            if (res) {
                                self.alert.showAlert('Sucesso', res);
                            }
                            else {
                                self.alert.showAlert('Erro', 'Erro ao atualizar permissão');
                            }
                        });
                    }
                },
                {
                    text: 'Sim',
                    handler: () => {
                        self.utilProvider.loadingShow();
                        self.userProvider.updateEmailMarketingPermission(self.user.SgunId, true).then(res => {
                            self.utilProvider.loadingHide();
                            if (res) {
                                self.alert.showAlert('Sucesso', res);
                            }
                            else {
                                self.alert.showAlert('Erro', 'Erro ao atualizar permissão');
                            }
                        });
                    }
                },
            ]
        });

        alert.present();
    }
}



// WEBPACK FOOTER //
// ./src/pages/atividade/atividade.ts